export default __webpack_public_path__ + "static/FreeTrial_01-43717a3a4d68b49052e52a9031a98f33.svg";